<template>
    <div class="detail-wrap">
        <van-collapse v-model="activeNames">
            <van-collapse-item title="职位人选目标画像" v-if="pageType == 1" name="1" class="item-list">
                <p class="tips">此数据基于职位要求得出</p>
                <ul class="list-info">
                    <li>
                        <span class="label">城市</span>
                        <p class="data" v-if="item3.cities&&item3.cities.length">
                        <span v-for="(item,index) in item3.cities" :key="index" v-if="index<1">
                          {{item.name}}
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">年薪范围</span>
                        <p class="data" v-if="item3.salaryRangeBean">
                            {{(item3.salaryRangeBean.min || 0) | numberDescFilter((item3.salaryRangeBean.max
                            || 0),'万')}}
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">年龄</span>
                        <p class="data" v-if="item3.ageRangeBean">
                            {{(item3.ageRangeBean.min || 0) | numberDescFilter((item3.ageRangeBean.max ||
                            0),'岁')}}
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">学历</span>
                        <p class="data" v-if="item3.degrees&&item3.degrees.length">
                        <span v-for="(item,index) in item3.degrees" :key="index" v-if="index<2">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">所学专业</span>
                        <p class="data" v-if="item3.profession&&item3.profession.length">
                        <span v-for="(item,index) in item3.profession" :key="index" v-if="index<5">
                          {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">工作总年限(年)</span>
                        <p class="data" v-if="item3.workYearRangeBean">
                            {{(item3.workYearRangeBean.min || 0) |
                            numberDescFilter((item3.workYearRangeBean.max || 0),'年')}}
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">行业/领域/背景</span>
                        <p class="data" v-if="item3.field&&item3.field.length">
                        <span v-for="(item,index) in item3.field" :key="index" v-if="index<1">
                          {{item.name}}
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">技术/语言</span>
                        <p class="data" v-if="item3.skill&&item3.skill.length">
                        <span v-for="(item,index) in item3.skill" :key="index" v-if="index<1">
                          {{item.name}}
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">稳定性</span>
                        <p class="data" v-if="item3.workStabilities&&item3.workStabilities.length">
                        <span v-for="(item,index) in item3.workStabilities" :key="index" v-if="index<1">
                          {{item.name}}
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                </ul>
            </van-collapse-item>
            <van-collapse-item title="评估通过人选画像" name="2" class="item-list">
                <p class="tips">此数据根据目前流程中的<span class="green">{{item1.total ? item1.total : 0}}</span>个评估通过候选人得出</p>
                <ul class="list-info">
                    <li>
                        <span class="label">城市</span>
                        <p class="data" v-if="item1.cities&&item1.cities.length">
                        <span v-for="(item,index) in item1.cities" :key="index" v-if="index<5">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">年薪范围</span>
                        <p class="data" v-if="item1.salaryRangeBean">
                            {{(item1.salaryRangeBean.min || 0) | numberDescFilter((item1.salaryRangeBean.max
                            || 0),'万')}}
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">年龄</span>
                        <p class="data" v-if="item1.ageRangeBean">
                            {{(item1.ageRangeBean.min || 0) | numberDescFilter((item1.ageRangeBean.max ||
                            0),'岁')}}
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">性别</span>
                        <p class="data" v-if="item1.genders&&item1.genders.length">
                        <span v-for="(item,index) in item1.genders" :key="index">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">学历</span>
                        <p class="data" v-if="item1.degrees&&item1.degrees.length">
                        <span v-for="(item,index) in item1.degrees" :key="index" v-if="index<2">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">学校类型</span>
                        <div v-if="item1.colleges&&item1.colleges.length">
                            <p class="data"
                               v-if="(item1.colleges.length==1&&item1.colleges[0].code==1) || item1.colleges.length>1">
                          <span v-for="(item,index) in item1.colleges" :key="index" v-if="item.code==1">
                              985/211占<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                          </span>
                            </p>
                            <p class="data" v-else>-</p>
                        </div>
                        <template v-else>
                            <p class="data">-</p>
                        </template>
                    </li>
                    <li>
                        <span class="label">所学专业</span>
                        <p class="data" v-if="item1.profession&&item1.profession.length">
                        <span v-for="(item,index) in item1.profession" :key="index" v-if="index<5">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">工作总年限(年)</span>
                        <p class="data" v-if="item1.workYearRangeBean">
                            {{(item1.workYearRangeBean.min || 0) |
                            numberDescFilter((item1.workYearRangeBean.max || 0),'年')}}
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">公司名称</span>
                        <!-- <p class="data" v-if="item1.topCompany&&item1.topCompany.length">
                          <span v-for="(item,index) in item1.topCompany" :key="index" v-if="index<5">
                            {{item.name}}{{Math.ceil(item.percent*100)}}%
                          </span>
                        </p> v-else-->
                        <p class="data">-</p>
                    </li>
                    <li>
                        <span class="label">公司派系</span>
                        <!-- <p class="data" v-if="item1.companyFaction&&item1.companyFaction.length">
                          <span v-for="(item,index) in item1.companyFaction" :key="index" v-if="index<5">
                            {{item.name}}{{Math.ceil(item.percent*100)}}%
                          </span>
                        </p> v-else -->
                        <p class="data">-</p>
                    </li>
                    <li>
                        <span class="label">行业/领域/背景</span>
                        <p class="data" v-if="item1.field&&item1.field.length">
                        <span v-for="(item,index) in item1.field" :key="index" v-if="index<5">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">是否带团队</span>
                        <p class="data" v-if="item1.leaders&&item1.leaders.length">
                        <span v-for="(item,index) in item1.leaders" :key="index" v-if="item.code==1 || item.code == 0">
                            {{item.code==1 ? '带团队' : '不带团队'}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">技术/语言</span>
                        <p class="data" v-if="item1.skill&&item1.skill.length">
                        <span v-for="(item,index) in item1.skill" :key="index" v-if="index<5">
                          {{item.name}}{{Math.ceil(item.percent*100)}}%
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">稳定性</span>
                        <p class="data" v-if="item1.workStabilities&&item1.workStabilities.length">
                        <span v-for="(item,index) in item1.workStabilities" :key="index" v-if="index<5">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">海外经验</span>
                        <template v-if="item1.overseas&&item1.overseas.length">
                            <p class="data"
                               v-if="(item1.overseas.length==1&&item1.overseas[0].code==1) || item1.overseas.length>1">
                          <span v-for="(item,index) in item1.overseas" :key="index" v-if="item.code==1">
                              有经验<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                          </span>
                            </p>
                            <p class="data" v-else>-</p>
                        </template>
                        <template v-else>
                            <p class="data">-</p>
                        </template>
                    </li>
                </ul>
            </van-collapse-item>
            <van-collapse-item title="面试通过人选画像" name="3" class="item-list">
                <p class="tips">此数据根据目前流程中的<span class="green">{{item2.total ? item2.total : 0}}</span>个面试通过候选人得出</p>
                <ul class="list-info">
                    <li>
                        <span class="label">城市</span>
                        <p class="data" v-if="item2.cities&&item2.cities.length">
                        <span v-for="(item,index) in item2.cities" :key="index" v-if="index<5">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">年薪范围</span>
                        <p class="data" v-if="item2.salaryRangeBean">
                            {{(item2.salaryRangeBean.min || 0) | numberDescFilter((item2.salaryRangeBean.max
                            || 0),'万')}}
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">年龄</span>
                        <p class="data" v-if="item2.ageRangeBean">
                            {{(item2.ageRangeBean.min || 0) | numberDescFilter((item2.ageRangeBean.max ||
                            0),'岁')}}
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">性别</span>
                        <p class="data" v-if="item2.genders&&item2.genders.length">
                        <span v-for="(item,index) in item2.genders" :key="index">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">学历</span>
                        <p class="data" v-if="item2.degrees&&item2.degrees.length">
                        <span v-for="(item,index) in item2.degrees" :key="index" v-if="index<2">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">学校类型</span>
                        <template v-if="item2.colleges&&item2.colleges.length">
                            <p class="data"
                               v-if="(item2.colleges.length==1&&item2.colleges[0].code==1) || item2.colleges.length>1">
                          <span v-for="(item,index) in item2.colleges" :key="index" v-if="item.code==1">
                              985/211占<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                          </span>
                            </p>
                            <p class="data" v-else>-</p>
                        </template>
                        <template v-else>
                            <p class="data">-</p>
                        </template>
                    </li>
                    <li>
                        <span class="label">所学专业</span>
                        <p class="data" v-if="item2.profession&&item2.profession.length">
                        <span v-for="(item,index) in item2.profession" :key="index" v-if="index<5">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">工作总年限(年)</span>
                        <p class="data" v-if="item2.workYearRangeBean">
                            {{(item2.workYearRangeBean.min || 0) |
                            numberDescFilter((item2.workYearRangeBean.max || 0),'年')}}
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">公司名称</span>
                        <!-- <p class="data" v-if="item2.topCompany&&item2.topCompany.length">
                          <span v-for="(item,index) in item2.topCompany" :key="index" v-if="index<5">
                            {{item.name}}{{Math.ceil(item.percent*100)}}%
                          </span>
                        </p> v-else-->
                        <p class="data">-</p>
                    </li>
                    <li>
                        <span class="label">公司派系</span>
                        <!-- <p class="data" v-if="item2.companyFaction&&item2.companyFaction.length">
                          <span v-for="(item,index) in item2.companyFaction" :key="index" v-if="index<5">
                            {{item.name}}{{Math.ceil(item.percent*100)}}%
                          </span>
                        </p> v-else -->
                        <p class="data">-</p>
                    </li>
                    <li>
                        <span class="label">行业/领域/背景</span>
                        <p class="data" v-if="item2.field&&item2.field.length">
                        <span v-for="(item,index) in item2.field" :key="index" v-if="index<5">
                          {{item.name}}{{Math.ceil(item.percent*100)}}%
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">是否带团队</span>
                        <p class="data" v-if="item2.leaders&&item2.leaders.length">
                        <span v-for="(item,index) in item2.leaders" :key="index" v-if="item.code==1 || item.code == 0">
                            {{item.code==1 ? '带团队' : '不带团队'}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">技术/语言</span>
                        <p class="data" v-if="item2.skill&&item2.skill.length">
                        <span v-for="(item,index) in item2.skill" :key="index" v-if="index<5">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">稳定性</span>
                        <p class="data" v-if="item2.workStabilities&&item2.workStabilities.length">
                        <span v-for="(item,index) in item2.workStabilities" :key="index" v-if="index<5">
                            {{item.name}}<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                        </span>
                        </p>
                        <p class="data" v-else>-</p>
                    </li>
                    <li>
                        <span class="label">海外经验</span>
                        <template v-if="item2.overseas&&item2.overseas.length">
                            <p class="data"
                               v-if="(item2.overseas.length==1&&item2.overseas[0].code==1) || item2.overseas.length>1">
                          <span v-for="(item,index) in item2.overseas" :key="index" v-if="item.code==1">
                              有经验<span v-if="item.percent > 0">{{Math.ceil(item.percent*100)}}%</span>
                          </span>
                            </p>
                            <p class="data" v-else>-</p>
                        </template>
                        <template v-else>
                            <p class="data">-</p>
                        </template>
                    </li>
                </ul>
            </van-collapse-item>
        </van-collapse>
    </div>
</template>

<script>
  import { getPositionPortraits } from "@/api/positions";
  import axios from "axios";

  export default {
    name: "portraisLens-module",
    props: {
        pid:{
            type:[String, Number],
            default:null
        },
        pageType: {
            type: Number,
            default: 1
        }
    },
    data() {
      return {
        positionId: this.$route.params.positionId,
        query: this.$route.query,
        activeNames: ["1", "2", "3"],
        item1: "",//评估通过
        item2: "",//面试通过
        item3: ""//推荐成功
      };
    },
    methods: {
      init() {
        this.getItem1(this.positionId, 1);
        this.getItem2(this.positionId, 2);
        this.getItem3(this.positionId, 3);
      },
      getItem1(id, type) {
        let query = {};
        query.positionId = id;
        query.portraitType = type;
        Object.assign(query, this.query);
        getPositionPortraits(this.positionId, query).then(res => {
          if (res && res.data) {
            this.item1 = res.data;
          }
        });
      },
      getItem2(id, type) {
        let query = {};
        query.positionId = id;
        query.portraitType = type;
        Object.assign(query, this.query);
        getPositionPortraits(this.positionId, query).then(res => {
          if (res && res.data) {
            this.item2 = res.data;
          }
        });
      },
      getItem3(id, type) {
        let query = {};
        query.positionId = id;
        query.portraitType = type;
        Object.assign(query, this.query);
        getPositionPortraits(this.positionId, query).then(res => {
          if (res && res.data) {
            this.item3 = res.data;
          }
        });
      }
    },
    created() {
      this.positionId = this.$route.params.positionId || this.pid;
      this.init();
    }
  };
</script>

<style scoped lang="scss">
    .detail-wrap {
        background-color: #f5f5f5;

        .item-list {
            &:not(:last-child) {
                margin-bottom: 10px;
            }

            .tips {
                color: #999;
                margin-bottom: 15px;
                font-size: 14px;
            }

            .list-info {
                line-height: 20px;

                li {
                    margin-bottom: 10px;
                    display: flex;
                    align-items: flex-start;
                    font-size: 14px;

                    .label {
                        width: 70px;
                        margin-right: 20px;
                        color: #666;
                    }

                    .data {
                        color: #333;
                        flex: 1;
                        span{
                            &:not(:last-child):after{
                                content: '、';
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    .detail-wrap .item-list .van-cell__title {
        font-size: 16px;
    }
</style>
